var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2176 18.5217C18.7376 18.5188 20.7798 16.4766 20.7828 13.9565V7.56522C20.7828 5.04392 18.7389 3 16.2176 3C13.6963 3 11.6523 5.04392 11.6523 7.56522V13.9565C11.6553 16.4766 13.6975 18.5188 16.2176 18.5217Z",
    fill: "#027BFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5217 12.1306C23.0175 12.1306 22.6087 12.5394 22.6087 13.0437V13.9567C22.6087 17.4865 19.7472 20.348 16.2174 20.348C12.6876 20.348 9.82609 17.4865 9.82609 13.9567V13.0437C9.82609 12.5394 9.4173 12.1306 8.91304 12.1306C8.40878 12.1306 8 12.5394 8 13.0437V13.9567C8.006 18.1389 11.1486 21.6511 15.3043 22.1202V26.7393H11.6522C11.1479 26.7393 10.7391 27.1481 10.7391 27.6524C10.7391 28.1566 11.1479 28.5654 11.6522 28.5654H20.7826C21.2869 28.5654 21.6957 28.1566 21.6957 27.6524C21.6957 27.1481 21.2869 26.7393 20.7826 26.7393H17.1304V22.1202C21.2862 21.6511 24.4288 18.1389 24.4348 13.9567V13.0437C24.4348 12.5394 24.026 12.1306 23.5217 12.1306Z",
    fill: "#027BFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.15a15794598d113dfc5fc2ba2d1094bd.svg";
export { ForwardRef as ReactComponent };